/**
 * Resolve a path to a file in the /public directory against Vite's configured
 * `base`.
 *
 * `import.meta.env.BASE_URL` is '/' in dev and '/crash-render-engine-fe/' in
 * prod/staging (see vite.config.js), and always ends with a slash. Public assets
 * are served at `base + path`, so referencing them with a bare leading-slash path
 * (e.g. '/audio/sounds/CLICK.mp3') 404s whenever the app is served from a
 * sub-path. Route every public-asset reference through this helper instead.
 *
 * @param {string} path - a public-relative path, with or without a leading slash
 * @returns {string} the base-prefixed URL
 */
export const assetUrl = (path) => `${import.meta.env.BASE_URL}${String(path).replace(/^\/+/, '')}`
